export const CLASSES = {
  IS_ACTIVE: "is-active",
  IS_OPEN: "is-open",
  IS_EDITABLE: "is-editable",
  IS_HIDDEN: "is-hidden",
  IS_VISIBLE: "is-visible",
  LOADER: "loader",
  LOADER_WRAPPER: "loader-wrapper",
  FORM_INPUT: "form-input",
  FORM_CHECKBOX: "checkbox",
  FORM_SUBMIT: "form-submit",
  TOOLTIP_ACTIVE: "tooltipstered"
};
